import React from "react";
import './student-engagement-report.scss';
import Dropdown from '../common/dropdown-v2/dropdown';
import SchoolApi from "../../apis/school";

class StudentEngagementReport extends React.Component {


    state = {
        boardsDropdownItems: [],
        monthsDrodownItems: [
            {
                title: 'September 2025',
                value: 'September 2025'
            }
        ]
    }

    componentDidMount() {
        this.getClasses()
    }

    getClasses(payload = {}) {

        this.setState({ isLoading: true })

        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = []
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }
                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }
                let selectedBoard = boards[0].value
                this.setState({
                    classes, boards, selectedBoard,
                    classDropdownItems: classes, boardsDropdownItems: boards, reloadDropdown: true
                }, () => {
                    this.setState({ reloadDropdown: false })
                })
            }).catch(err => {
            })
    }

    onSelectDropDown = (option, key) => {
        // console.log(option, key)
        this.setState({ [key]: option?.value, }, () => {


            if (key === "selectedBoard") {
            }
        })
    }


    getStudentEngagementActivityReport() {

        let payload = {
            board : this.state.selectedBoard,
            month : this.state.selectedMonth
        }

        SchoolApi.getStudentEngagementReport(payload).then(res => {
            console.log(res)
        }).catch(err => {
            console.log(err)
        })

    }


    render() {
        return (
            <div className="student-engagement-report">
                <div>
                    <div className="title">Student Engagement Report</div>
                </div>

                <div className="row student-leaderboard-class-filter mr-4">
                    {
                        this.state.boardsDropdownItems.length > 1 ?
                            <div className="col-lg-2 col-md-6 col-sm-12 pt-4">
                                <div className="filter-input-label">
                                    Select Board<span className='text-danger'>*</span>
                                </div>
                                <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                                    <Dropdown
                                        placeholder='Select a board'
                                        options={this.state.boardsDropdownItems}
                                        onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                        text={"title"}
                                        value={this.state.selectedBoard}
                                    />
                                </div>
                                {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                            </div>
                            : ""
                    }
                    {

                        <div className="col-lg-2 col-md-6 col-sm-12 pt-4">
                            <div className="filter-input-label">
                                Select Month<span className='text-danger'>*</span>
                            </div>
                            <div className={this.props.isCreate && !this.state.selectedMonth ? 'error-border' : ''}>
                                <Dropdown
                                    placeholder='Select a Month'
                                    options={this.state.monthsDrodownItems}
                                    onSelect={(option) => this.onSelectDropDown(option, "selectedMonth")}
                                    text={"title"}
                                    value={this.state.selectedMonth}
                                />
                            </div>
                            {this.props.isCreate && !this.state.selectedMonth ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                        </div>
                    }
                    <div className="col-lg-2 col-md-6 col-sm-12 pt-4 cursor-pointer" onClick={() => this.getStudentEngagementActivityReport()}>Go</div>
                    <div className="col-lg-2 col-md-6 col-sm-12 pt-4 cursor-pointer">Clear</div>
                </div>
            </div>
        )
    }
}

export default StudentEngagementReport;